<!-- Update to dz-tooltip once its updated -->
<dz-icon *ngIf="dcrValue" type="info-circle" class="info-circle color-blk-purple" (click)="onClick($event)" [dz-tippy-tooltip]="dcrValue"></dz-icon>
